import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@telus-uds/components-web';
import styled from 'styled-components';

import { FieldWrapper } from './css';
import formFieldOperationOptions from '../utils/formFieldOperationOptions';
import Note from '../note';
import { getLocale } from '../misc';
import EN from '../../EN.json';
import FR from '../../FR.json';

const ChooseFileButton = styled.label`
  display: inline-block;
  margin: 0.5em 0;
  padding: 0.25em 0.75em;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  font-family: inherit;
  text-align: center;
  color: #333;
  background-color: #f5f5f5;
  border: 1px solid #ccc;
  border-radius: 2px;
  cursor: pointer;
  box-sizing: border-box;

  &:hover {
    background-color: #e8e8e8;
    border-color: #b3b3b3;
  }

  &:focus {
    outline: 1px dotted #333;
    outline-offset: 2px;
  }
`;

const HiddenFileInput = styled.input`
  position: absolute;
  width: 0;
  height: 0;
  opacity: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
`;

const getValueDisplayString = value => {
  if (value == null || value === '') return '';
  if (typeof File !== 'undefined' && value instanceof File) {
    return value.name;
  }
  return value;
};

const FieldFile = ({ data }) => {
  const {
    ref,
    name,
    label,
    required,
    onChange,
    note,
    value,
    noteAppearsBelowField,
    isShowNoteBackground
  } = data;

  const inputId = `file-input-${name}`;

  const locale = getLocale();
  const chooseFileLabel =
    (locale === 'en-US' ? EN : FR).general.chooseFile || 'Choose File';

  const renderNotes = () => {
    return (
      note &&
      note.content && (
        <Note
          type="richText"
          options={formFieldOperationOptions(value)}
          data={note}
          isShowNoteBackground={isShowNoteBackground}
        />
      )
    );
  };

  return (
    <FieldWrapper>
      <div>
        <Typography>
          {label}
          {required && `*`}
        </Typography>
        {note && note.content && !noteAppearsBelowField && renderNotes()}
      </div>
      <span style={{ position: 'relative', display: 'inline-flex', alignItems: 'center', gap: '0.5rem' }}>
        <HiddenFileInput
          ref={ref}
          id={inputId}
          type="file"
          name={name}
          onChange={onChange}
          accept="application/msword, application/pdf, image/jpeg, image/png"
          aria-hidden="true"
          tabIndex={-1}
        />
        <ChooseFileButton htmlFor={inputId}>
          {chooseFileLabel}
        </ChooseFileButton>
        {value && (
          <span className="frg-body-font-14px">{getValueDisplayString(value)}</span>
        )}
      </span>
      {name === 'documentFMSOW' && (
        <p>Currently Uploading File: {getValueDisplayString(value)}</p>
      )}
      {note && note.content && noteAppearsBelowField && renderNotes()}
    </FieldWrapper>
  );
};

FieldFile.propTypes = {
  data: PropTypes.shape({
    ref: PropTypes.object,
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(File)]),
    required: PropTypes.bool,
    note: PropTypes.shape({
      content: PropTypes.arrayOf(PropTypes.object)
    }),
    onChange: PropTypes.func.isRequired,
    noteAppearsBelowField: PropTypes.bool.isRequired
  }).isRequired
};

export default FieldFile;
